import _ from "lodash";
import moment from "moment";
import Uuid from "../../../../support/Uuid";

class ComplementoCartaPorteInputPipe {
  getName() {
    return "CartaPorte";
  }

  apply(data, comprobante) {
    const { Complemento } = data;

    if (!Complemento || !Complemento.CartaPorte) {
      return data;
    }

    let { CartaPorte } = Complemento;

    let {
      RegimenesAduaneros = {},
      Ubicaciones = {},
      Mercancias = {},
      FiguraTransporte = {},
    } = CartaPorte;
    let { RegimenAduaneroCCP = [] } = RegimenesAduaneros;
    let { Ubicacion = [] } = Ubicaciones;
    let { Mercancia = [], Autotransporte = {} } = Mercancias;
    let { TiposFigura = [] } = FiguraTransporte;

    if (!!RegimenAduaneroCCP) {
      RegimenAduaneroCCP = _.map(RegimenAduaneroCCP, (item) => {
        item.id = Uuid.v4();

        return item;
      });
    }

    if (!!Ubicacion) {
      Ubicacion = _.map(Ubicacion, (item) => {
        item.id = Uuid.v4();
        item.FechaHoraSalidaLlegada = moment(
          item.FechaHoraSalidaLlegada
        ).toDate();

        return item;
      });
    }

    if (!!Mercancia) {
      Mercancia = _.map(Mercancia, (item) => {
        item.id = Uuid.v4();

        if (!!item.Pedimentos) {
          item.Pedimentos = _.map(item.Pedimentos, (Pedimentos) => {
            Pedimentos.id = Uuid.v4();

            return Pedimentos;
          });
        }

        if (!!item.DocumentacionAduanera) {
          item.DocumentacionAduanera = _.map(
            item.DocumentacionAduanera,
            (DocumentacionAduanera) => {
              DocumentacionAduanera.id = Uuid.v4();

              return DocumentacionAduanera;
            }
          );
        }

        if (!!item.CantidadTransporta) {
          item.CantidadTransporta = _.map(
            item.CantidadTransporta,
            (CantidadTransporta) => {
              CantidadTransporta.id = Uuid.v4();

              return CantidadTransporta;
            }
          );
        }

        if (!!item.GuiasIdentificacion) {
          item.GuiasIdentificacion = _.map(
            item.GuiasIdentificacion,
            (GuiasIdentificacion) => {
              GuiasIdentificacion.id = Uuid.v4();

              return GuiasIdentificacion;
            }
          );
        }

        return item;
      });
    }

    if (!!Autotransporte) {
      if (!!Autotransporte.Remolques) {
        Autotransporte.Remolques.Remolque = _.map(
          Autotransporte.Remolques.Remolque,
          (Remolque) => {
            Remolque.id = Uuid.v4();

            return Remolque;
          }
        );
      }
    }

    if (!!TiposFigura) {
      TiposFigura = _.map(TiposFigura, (item) => {
        item.id = Uuid.v4();

        if (!!item.PartesTransporte) {
          item.PartesTransporte = _.map(
            item.PartesTransporte,
            (PartesTransporte) => {
              PartesTransporte.id = Uuid.v4();

              return PartesTransporte;
            }
          );
        }

        return item;
      });
    }

    data.Complemento.CartaPorte = {
      ...CartaPorte,
      RegimenesAduaneros: {
        RegimenAduaneroCCP: [...RegimenAduaneroCCP],
      },
      Ubicaciones: {
        Ubicacion: [...Ubicacion],
      },
      Mercancias: {
        ...Mercancias,
        Mercancia: [...Mercancia],
        Autotransporte: {
          ...Autotransporte,
        },
      },
      FiguraTransporte: {
        TiposFigura: [...TiposFigura],
      },
    };

    return data;
  }
}

export default ComplementoCartaPorteInputPipe;
